import type { ColumnDef } from "@tanstack/react-table";
import type { ApprovalLevelRow } from "../types/ApprovalLevel";

export const businessApprovalColumns: ColumnDef<ApprovalLevelRow>[] = [
  { accessorKey: "name", header: "Name" },
  {
    accessorKey: "signaturesRequired",
    header: "# Approvals",
  },
  {
    id: "triggers",
    header: "Trigger",
    cell: ({ row }) => row.original.triggerDescription || "—",
  },
  {
    accessorKey: "submitterMayApprove",
    header: "Submitter Approves?",
    cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
  },
  {
    accessorKey: "limitApprovalsToTeam",
    header: "Team Approval?",
    cell: ({ getValue }) => (getValue() ? "Yes" : "No"),
  },
];
